import { render } from "./FormNameCompanion.vue?vue&type=template&id=46a82c3c&ts=true"
import script from "./FormNameCompanion.vue?vue&type=script&lang=ts"
export * from "./FormNameCompanion.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__